import React from 'react';
import { Typography, Box } from '@mui/material';
import ArticlesList from '../components/ArticlesList';
import { Routes, Route } from 'react-router-dom';
import ArticleDetail from '../components/ArticleDetail';
import { useProject } from '../contexts/ProjectContext';

const Articles = () => {
  const { selectedProject } = useProject();
  
  return (
    <Box sx={{ p: 3 }}>
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Typography variant="h4" component="h1" gutterBottom align="center">
                {selectedProject ? selectedProject.name : 'All Articles'}
              </Typography>
              <ArticlesList projectId={selectedProject?.id} />
            </>
          }
        />
        <Route path="/:articleId" element={<ArticleDetail />} />
      </Routes>
    </Box>
  );
};

export default Articles; 